const news = {
  namespaced: true,
  state () {
    return {
      newsId: null
    }
  },
  mutations: {
    setNewsId (state, val) {
      state.setNewsId = val
    }
  },
  actions: {
  },
  getters: {
    getPNewsId (state) {
      return state.setNewsId
    }
  }
}
export default news



// WEBPACK FOOTER //
// ./src/store/module/news.js